<!-- <!DOCTYPE html>
<html> -->

<!-- <head>
	<meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
	<title>Confirmation Conference Registration</title>
	<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0," />
	<link href='https://fonts.googleapis.com/css?family=Open+Sans:400,300,300italic,400italic,600,600italic,700,700italic,800,800italic'
	 rel='stylesheet' type='text/css' />
</head> -->

<body *ngIf="confirmation$ | async as confirmation">

	<!-- SUB BANNER -->
	<!-- <section class="section-sub-banner awe-parallax bg-16">

		<div class="awe-overlay"></div>

		<div class="sub-banner">
			<div class="container">
				<div class="text text-center">
					<h2>PLEASE PRINT CONFIRMATION BELOW</h2>
					<p></p>
				</div>
			</div>

		</div>

	</section> -->
	<!-- END / SUB BANNER -->

	<!-- MENU STARTS -->
	<table style="margin-top: 70px;" align="center" bgcolor="#333333" border="0" cellpadding="0" cellspacing="0" width="100%">
		<tbody>
			<tr>
				<td align="center">
					<table align="center" bgcolor="#ffffff" border="0" cellpadding="0" cellspacing="0" class="display-width" width="680">
						<tr>
							<td align="center" style="padding:0 30px;">
								<table align="center" border="0" cellpadding="0" cellspacing="0" class="display-width" width="600">
									<tr>
										<td height="15"></td>
									</tr>
									<tr>
										<td align="center">
											<table align="center" border="0" cellpadding="0" cellspacing="0" class="display-width" width="100%">
												<tr>
													<td>
														<table align="left" border="0" cellpadding="0" cellspacing="0" class="display-width" width="25%" style="border-collapse:collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;">
															<tr>
																<td align="center" valign="middle">
																	<a href="#" style="color:#444444;text-decoration:none;">
																		<img src="assets/images/emp21-logo.jpeg" alt="Empowered21" width="90" />
																	</a>
																</td>
															</tr>
														</table>

														<table align="left" border="0" cellpadding="0" cellspacing="0" width="1" style="border-collapse:collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;">
															<tbody>
																<tr>
																	<td style="line-height:20px;" height="20" width="1"></td>
																</tr>
															</tbody>
														</table>

														<table align="right" border="0" cellpadding="0" cellspacing="0" class="display-width" width="54%" style="border-collapse:collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;width:auto;">
															<tr>
																<td valign="middle">
																	<table align="center" border="0" cellspacing="0" cellpadding="0" style="width:auto !important;">
																		<tr>
																			<td height="15" class="hide-height"></td>
																		</tr>
																		<tr>
																			<td width="5">&nbsp;</td>
																			<td align="left" valign="middle" class="MsoNormal menu" style="color:#03a9f4;font-family:'Segoe UI',sans-serif,Arial,Helvetica,Lato;font-size:11px;font-weight:600;letter-spacing:1px;">
																				<a href="#" style="color:#03a9f4;text-decoration:none;">
																					CONFERENCE CONFIRMATION
																				</a>
																			</td>

																			<td width="5">&nbsp;</td>


																		</tr>
																		<tr>
																			<td height="15" class="hide-height"></td>
																		</tr>
																	</table>
																</td>
															</tr>
														</table>
													</td>
												</tr>
											</table>
										</td>
									</tr>
								</table>
							</td>
						</tr>
						<tr>
							<td height="15" style="border-bottom:1px solid #eeeeee;"></td>
						</tr>
					</table>
				</td>
			</tr>
		</tbody>
	</table>

	<!-- MENU ENDS -->

	<!-- SHIPMENT CONFIRMATION STARTS -->

	<table align="center" bgcolor="#333333" border="0" cellpadding="0" cellspacing="0" width="100%">
		<tr>
			<td align="center">
				<table align="center" bgcolor="#ffffff" border="0" cellpadding="0" cellspacing="0" class="display-width" width="680">
					<tr>
						<td align="center" style="border-bottom:1px solid #eeeeee;padding:0 30px;">
							<table align="center" border="0" cellpadding="0" cellspacing="0" class="display-width" width="600">
								<tr>
									<td align="center">
										<table align="center" border="0" cellpadding="0" cellspacing="0" class="display-width" width="100%">
											<tr>
												<td height="40"></td>
											</tr>
											<tr>
												<td align="right" class="MsoNormal" style="color:#333333;font-family:'Segoe UI',sans-serif,Arial,Helvetica,Lato;font-size:20px;font-weight:600;letter-spacing:1px;line-height:18px;text-transform:capitalize;">
													EMPOWERED21 CONFERENCE
												</td>
											</tr>
											<tr>
												<td height="10"></td>
											</tr>
											<tr>
												<td align="right" class="MsoNormal" style="color:#333333;font-family:'Segoe UI',sans-serif,Arial,Helvetica,Lato;font-size:11px;letter-spacing:1px;line-height:18px;text-transform:capitalize;">

												</td>
											</tr>
											<!-- <tr>
												<td height="30"></td>
											</tr> -->
											<tr>
												<td align="left" class="MsoNormal" style="color:#333333;font-family:'Segoe UI',sans-serif,Arial,Helvetica,Lato;font-size:18px;font-weight:600;letter-spacing:1px;line-height:18px;text-transform:capitalize;">
													Attention: {{confirmation.title}} {{confirmation.userName}}
												</td>
											</tr>
											<tr>
												<td height="20"></td>
											</tr>
											<tr>
												<td align="left">
													<table align="left" border="0" cellpadding="0" cellspacing="0" class="display-width" width="100%">
														<tr>
															<td align="left" class="MsoNormal" style="color:#666666;font-family:'Segoe UI',sans-serif,Arial,Helvetica,Lato;font-size:13px;line-height:24px;">
																Thank you for making payment for the EMPOWERED21 CONFERENCE. The receipt for your payment has been emailed to you.
															</td>
														</tr>
													</table>
												</td>
											</tr>
											<!-- <tr>
												<td height="30"></td>
											</tr> -->
											<tr>
												<td style="border-bottom:3px solid #333333;"></td>
											</tr>
											<!-- <tr>
												<td align="left" bgcolor="#f5f5f5">
													<table align="left" border="0" cellpadding="0" cellspacing="0" class="display-width" width="100%">
														<tr>
															<td height="30"></td>
														</tr>
														<tr>
															<td style="padding:0 30px;">
																<table align="left" border="0" cellpadding="0" cellspacing="0" class="display-width" width="48%" style="border-collapse:collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;">
																	<tr>
																		<td align="left">
																			<table align="left" border="0" cellpadding="0" cellspacing="0" class="display-width" width="100%" style="width:auto !important;">
																				<tr>
																					<td align="left" class="MsoNormal" style="color:#666666;font-family:'Segoe UI',sans-serif,Arial,Helvetica,Lato;font-size:13px;letter-spacing:1px;line-height:15px;">
																						Conference Start Date:
																					</td>
																				</tr>

																				<tr>
																					<td align="left" class="MsoNormal" style="color:#333333;font-family:'Segoe UI',sans-serif,Arial,Helvetica,Lato;font-size:13px;font-weight:600;letter-spacing:1px;line-height:20px;text-transform:uppercase;">
																						Wednesday, May 16,2018
																					</td>
																				</tr>
																				<tr>
																					<td height="15"></td>
																				</tr>
																				<tr>
																					<td align="left" class="MsoNormal" style="color:#666666;font-family:'Segoe UI',sans-serif,Arial,Helvetica,Lato;font-size:13px;letter-spacing:1px;line-height:15px;">
																						Conference End Date:
																					</td>
																				</tr>

																				<tr>
																					<td align="left" class="MsoNormal" style="color:#333333;font-family:'Segoe UI',sans-serif,Arial,Helvetica,Lato;font-size:13px;font-weight:600;letter-spacing:1px;line-height:20px;text-transform:uppercase;">
																						Saturday, May 19,2018
																					</td>
																				</tr>

																			</table>
																		</td>
																	</tr>
																</table>

																<table align="left" border="0" cellpadding="0" cellspacing="0" width="1" style="border-collapse:collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;">
																	<tbody>
																		<tr>
																			<td style="line-height:40px;" height="40" width="1"></td>
																		</tr>
																	</tbody>
																</table>

																<table align="right" border="0" cellpadding="0" cellspacing="0" class="display-width" width="48%" style="border-collapse:collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;">
																	<tr>
																		<td align="left">
																			<table align="left" border="0" cellpadding="0" cellspacing="0" class="display-width" width="100%" style="width:auto !important;">
																				<tr>
																					<td align="left" class="MsoNormal" style="color:#666666;font-family:'Segoe UI',sans-serif,Arial,Helvetica,Lato;font-size:13px;letter-spacing:1px;line-height:15px;">
																						Your Details:
																					</td>
																				</tr>
																				<tr>
																					<td align="left" class="MsoNormal" style="color:#333333;font-family:'Segoe UI',sans-serif,Arial,Helvetica,Lato;font-size:13px;font-weight:600;letter-spacing:1px;line-height:24px;text-transform:uppercase;">
																						Name: {{confirmation.userName}}
																						<br/> Passport / ID: {{confirmation.idNumber}}
																					</td>
																				</tr>
																			</table>
																		</td>
																	</tr>
																</table>
															</td>
														</tr>

													</table>
												</td>
											</tr> -->
											<!-- <tr>
												<td height="30"></td>
											</tr> -->
											<!-- <tr>
												<td align="left">
													<table align="left" border="0" cellpadding="0" cellspacing="0" class="display-width" width="100%">
														<tr>
															<td align="left" class="MsoNormal" style="color:#666666;font-family:'Segoe UI',sans-serif,Arial,Helvetica,Lato;font-size:13px;line-height:24px;">
																<p></p>
															</td>
														</tr>
													</table>
												</td>
											</tr> -->
										</table>
									</td>
								</tr>
							</table>
						</td>
					</tr>
				</table>
			</td>
		</tr>
	</table>

	<!-- SHIPMENT CONFIRMATION ENDS -->
	<!-- QR CODE STARTS -->

	<table align="center" bgcolor="#333333" border="0" cellpadding="0" cellspacing="0" width="100%">
		<tr>
			<td align="center">
				<table align="center" bgcolor="#ffffff" border="0" cellpadding="0" cellspacing="0" class="display-width" width="680">
					<tr>
						<td align="center" style="border-bottom:1px solid #eeeeee;padding:0 30px;">
							<table align="center" border="0" cellpadding="0" cellspacing="0" class="display-width" width="600">
								<tr>
									<td align="center">
										<table align="center" border="0" cellpadding="0" cellspacing="0" class="display-width" width="100%">

											<tr>
												<td height="10">
													<strong>
														<em>NOTE: Please keep this document after printing and provide at the entrance to be scanned. The code below authenticates
															you.
														</em>
													</strong>
												</td>
											</tr>
											<tr>
												<td align="left" class="MsoNormal text-center" style="color:#666666;font-family:'Segoe UI',sans-serif,Arial,Helvetica,Lato;font-size:13px;line-height:13px;">
													<!-- QR CODE GENERATOR -->
													<ngx-kjua [text]="confirmation.userId" [renderAsync]="false" [render]="'image'" [crisp]="true" [minVersion]="1" [ecLevel]="'H'"
													 [size]="400" [ratio]="undefined" [fill]="'#333'" [back]="'#fff'" [rounded]="100" [quiet]="1" [mode]="'plain'"
													 [mSize]="30" [mPosX]="50" [mPosY]="50" [label]="'label text'" [fontname]="'sans-serif'" [fontcolor]="'#ff9818'"
													 [image]="undefined"></ngx-kjua>
												</td>
											</tr>
											<tr>
												<td height="5"></td>
											</tr>
											<!-- <tr>
												<td align="left" class="MsoNormal" style="color:#333333;font-family:'Segoe UI',sans-serif,Arial,Helvetica,Lato;font-size:15px;font-weight:600;line-height:24px;">
													Empowered21 Conference Team.
												</td>
											</tr> -->

										</table>
									</td>
								</tr>
							</table>
						</td>
					</tr>
				</table>
			</td>
		</tr>
	</table>

	<!-- QR CODE ENDS -->

	<!-- COMPANY NAME STARTS -->

	<table align="center" bgcolor="#333333" border="0" cellpadding="0" cellspacing="0" width="100%">
		<tr>
			<td align="center">
				<table align="center" bgcolor="#ffffff" border="0" cellpadding="0" cellspacing="0" class="display-width" width="680">
					<tr>
						<td align="center" style="border-bottom:1px solid #eeeeee;padding:0 30px;">
							<table align="center" border="0" cellpadding="0" cellspacing="0" class="display-width" width="600">
								<tr>
									<td align="center">
										<table align="center" border="0" cellpadding="0" cellspacing="0" class="display-width" width="100%">

											<tr>
												<td height="10"></td>
											</tr>
											<tr>
												<td align="left" class="MsoNormal" style="color:#666666;font-family:'Segoe UI',sans-serif,Arial,Helvetica,Lato;font-size:13px;line-height:13px;">
													Have a wonderful trip as you come to South Africa. We hope to see you soon!
												</td>
											</tr>
											<tr>
												<td height="5"></td>
											</tr>
											<tr>
												<td align="left" class="MsoNormal" style="color:#333333;font-family:'Segoe UI',sans-serif,Arial,Helvetica,Lato;font-size:15px;font-weight:600;line-height:24px;">
													Empowered21 Conference Team.
												</td>
											</tr>

										</table>
									</td>
								</tr>
							</table>
						</td>
					</tr>
				</table>
			</td>
		</tr>
	</table>

	<!-- COMPANY NAME ENDS -->

	<!-- THREE COLUMN : PRODUCT IMAGE STARTS -->

	<table align="center" bgcolor="#333333" border="0" cellpadding="0" cellspacing="0" width="100%">
		<tr>
			<td align="center">
				<table align="center" border="0" cellpadding="0" cellspacing="0" class="display-width" width="100%">
					<tr>
						<td align="center">
							<table align="center" bgcolor="#ffffff" border="0" cellpadding="0" cellspacing="0" class="display-width" width="680">
								<tr>
									<td align="center" style="padding:0 30px;">
										<table align="center" border="0" cellpadding="0" cellspacing="0" class="display-width" width="600">
											<tr>
												<td align="center">
													<table align="center" border="0" cellpadding="0" cellspacing="0" class="display-width" width="100%">
														<tr>
															<td height="30"></td>
														</tr>
														<tr>
															<td width="190">


																<!--[if gte mso 9]>
																	</td><td width="15">													
																	<![endif]-->

																<table align="left" border="0" cellpadding="0" cellspacing="0" width="15" style="border-collapse:collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;mso-hide:all;">
																	<tr>
																		<td style="line-height:40px;" height="40" width="1"></td>
																	</tr>
																</table>


																<!-- TABLE RIGHT -->

																<table align="right" border="0" cellpadding="0" cellspacing="0" class="display-width" width="190" style="border-collapse:collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;">
																	<tr>
																		<td align="center">
																			<table align="center" border="0" cellpadding="0" cellspacing="0" class="display-width" width="100%" style="width:auto !important;">

																				<tr>
																					<td align="left">
																						<table align="left" border="0" cellpadding="0" cellspacing="0" class="display-width" width="100%">
																							<tr>
																								<td align="right">
																									<table align="right" border="0" cellpadding="0" cellspacing="0" class="display-width" width="86%" style="width:auto !important;">
																										<tr>
																											<td align="left" valign="middle" class="MsoNormal menu" style="color:#03a9f4;font-family:'Segoe UI',sans-serif,Arial,Helvetica,Lato;font-size:13px;font-weight:bold;letter-spacing:1px;text-transform:uppercase;">
																												<button onclick="window.print()" style="color:#03a9f4;text-decoration:none;">
																													PRINT NOW
																												</button>
																												<button [routerLink]="['/bookings']" style="color:#03a9f4;text-decoration:none;">
																													GO BACK
																												</button>
																											</td>
																											<td width="5">
																												<a href="#" style="color:#03a9f4;text-decoration:none;"></a>
																											</td>
																											<td align="left" valign="middle">
																												<a href="#" style="color:#03a9f4;text-decoration:none;">
																													<!-- <img src="http://pennyblacktemplates.com/demo/notifications/order-confirmation/images/12x12x1.png" alt="12x12x1" width="12"/> -->
																												</a>
																											</td>
																										</tr>
																									</table>
																								</td>
																							</tr>
																						</table>
																					</td>
																				</tr>
																			</table>
																		</td>
																	</tr>
																</table>
															</td>
														</tr>
													</table>
												</td>
											</tr>
											<tr>
												<td height="30"></td>
											</tr>
										</table>
									</td>
								</tr>
							</table>
						</td>
					</tr>
				</table>
			</td>
		</tr>
	</table>

	<!-- THREE COLUMN : PRODUCT IMAGE ENDS -->

	<!-- FOOTER STARTS -->

	<table align="center" bgcolor="#333333" border="0" cellpadding="0" cellspacing="0" width="100%">
		<tr>
			<td align="center">
				<table align="center" border="0" cellpadding="0" cellspacing="0" class="display-width" width="100%">
					<tr>
						<td align="center">
							<table align="center" bgcolor="#03a9f4" border="0" cellpadding="0" cellspacing="0" class="display-width" width="680">
								<tr>
									<td align="center" style="padding:0 30px;">
										<table align="center" border="0" cellpadding="0" cellspacing="0" class="display-width" width="600">
											<tr>
												<td align="center">
													<table align="center" border="0" cellpadding="0" cellspacing="0" class="display-width" width="100%">
														<tr>
															<td height="30"></td>
														</tr>
														<tr>
															<td>

																<!-- TABLE LEFT -->

																<table align="left" border="0" cellpadding="0" cellspacing="0" class="display-width" width="43%" style="border-collapse:collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;width:auto;">
																	<tbody>
																		<tr>
																			<td align="center">
																				<table align="center" border="0" cellpadding="0" cellspacing="0" class="display-width" width="100%" style="width:auto !important;">
																					<tr>
																						<td align="left" class="MsoNormal" style="color:#ffffff;font-family:'Segoe UI',sans-serif,Arial,Helvetica,Lato;font-size:14px;letter-spacing:1px;line-height:24px;">
																							Copyright &copy; 2018, Empowered21 Conference
																						</td>
																					</tr>
																				</table>
																			</td>
																		</tr>
																	</tbody>
																</table>

																<table align="left" border="0" cellpadding="0" cellspacing="0" width="15%" style="border-collapse:collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;">
																	<tr>
																		<td style="line-height:20px;" height="20" width="1"></td>
																	</tr>
																</table>

																<!-- TABLE RIGHT -->

																<table align="right" border="0" cellpadding="0" cellspacing="0" class="display-width" width="37%" style="border-collapse:collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;width:auto;">
																	<tr>
																		<td align="center">
																			<!-- <table align="center" border="0" cellspacing="0" cellpadding="0" class="display-width" style="width:auto !important;">
																					<tr>
																						<td align="left" class="MsoNormal" style="color:#ffffff;font-family:'Segoe UI',sans-serif,Arial,Helvetica,Lato;font-size:14px;letter-spacing:1px;line-height:24px;">
																								Follow Us
																						</td>
																						<td width="20" class="follow">&nbsp;</td>
																						<td align="left">
																							<a href="#" style="color:#ffffff;text-decoration:none;">
																								<img src="http://pennyblacktemplates.com/demo/notifications/order-confirmation/images/25x25x1.png" alt="25x25x1" width="25"/>
																							</a>
																						</td>
																						<td width="10">&nbsp;</td>
																						<td align="left">
																							<a href="#" style="color:#ffffff;text-decoration:none;">
																								<img src="http://pennyblacktemplates.com/demo/notifications/order-confirmation/images/25x25x2.png" alt="25x25x2" width="25"/>
																							</a>
																						</td>
																						<td width="10">&nbsp;</td>
																						<td align="left">
																							<a href="#" style="color:#ffffff;text-decoration:none;">
																								<img src="http://pennyblacktemplates.com/demo/notifications/order-confirmation/images/25x25x3.png" alt="25x25x3" width="25"/>
																							</a>
																						</td>
																						<td width="10">&nbsp;</td>
																						<td align="left">
																							<a href="#" style="color:#ffffff;text-decoration:none;">
																								<img src="http://pennyblacktemplates.com/demo/notifications/order-confirmation/images/25x25x4.png" alt="25x25x4" width="25"/>
																							</a>
																						</td>																	
																					</tr>
																				</table> -->
																		</td>
																	</tr>
																</table>
															</td>
														</tr>
													</table>
												</td>
											</tr>
											<tr>
												<td height="30"></td>
											</tr>
										</table>
									</td>
								</tr>
							</table>
						</td>
					</tr>
				</table>
			</td>
		</tr>
	</table>

	<!-- FOOTER ENDS -->

</body>

<!-- </html> -->


// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/confirmation/conference/conference.component.html